import {
  getGetPayoutHistoryApiV1QueryKey,
  getGetPayoutMethodsApiV1QueryKey,
  getGetPayoutStatusApiV1QueryKey,
  getGetSettlementHistoryApiV1QueryKey,
  getGetTaxInformationApiV1QueryKey,
} from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const useResetPayoutQuery = () => {
  const queryClient = useQueryClient();
  const workspaceId = useWorkspaceId();
  return useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: getGetPayoutHistoryApiV1QueryKey(workspaceId) }),
      queryClient.invalidateQueries({ queryKey: getGetPayoutStatusApiV1QueryKey(workspaceId) }),
      queryClient.invalidateQueries({ queryKey: getGetPayoutMethodsApiV1QueryKey(workspaceId) }),
      queryClient.invalidateQueries({ queryKey: getGetSettlementHistoryApiV1QueryKey(workspaceId) }),
      queryClient.invalidateQueries({ queryKey: getGetTaxInformationApiV1QueryKey(workspaceId) }),
    ]);
  }, [queryClient, workspaceId]);
};
